import { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import AiChatCarouselSlide from '../ai-chat-carousel-slide';
import HeroCarouselSlideOne from './new-hero-carousel-slide-one';
import HeroCarouselSlideTwo from './new-hwro-carousel-slide-2';
import { useRecoilState } from 'recoil';
import { carouselMessageState } from '../../recoil/atoms';
import HeroCarouselSlideFour from './new-hero-carousel-slide-4';
import NewHeroCarouselSlideFive from './new-hero-carousel-slide-five';
import NewHeroCarouselSlideSix from './new-hero-carousel-slide-six';

const slides = [
  {
    id: 1,
    slide: HeroCarouselSlideOne
  },
  {
    id: 2,
    slide: AiChatCarouselSlide
  },
  {
    id: 3,
    slide: HeroCarouselSlideTwo
  },
  {
    id: 4,
    slide: HeroCarouselSlideFour
  },
  {
    id: 5,
    slide: NewHeroCarouselSlideFive
  },
  {
    id: 6,
    slide: NewHeroCarouselSlideSix
  }
];

const NewHeroCarousel = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const [carouselMessage] = useRecoilState(carouselMessageState);
  const [swiperInstance, setSwiperInstance] = useState(null);

  useEffect(() => {
    if (swiperInstance) {
      if (carouselMessage) {
        swiperInstance.autoplay.stop();
      } else {
        swiperInstance.autoplay.start();
      }
    }
  }, [carouselMessage, swiperInstance]);

  return (
    <div className='carousel__container'>
      <Swiper
        onSwiper={setSwiperInstance}
        spaceBetween={40}
        onSlideChange={swiper => setActiveIndex(swiper.activeIndex)}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        modules={[Autoplay, Pagination, Navigation]}
        className='carousel__slides-container'
      >
        {slides.map((slide, index) => {
          const SlideComponent = slide.slide;
          return (
            <SwiperSlide key={index}>
              <SlideComponent />
            </SwiperSlide>
          );
        })}
      </Swiper>

      <div className='carousel-nav--dots'>
        {slides.map((_, index) => (
          <div
            key={index}
            onClick={() => swiperInstance?.slideTo(index)}
            className={`carousel__nav-dot ${activeIndex === index ? 'carousel__nav-dot--active' : 'carousel__nav-dot--inactive'}`}
          />
        ))}
      </div>
    </div>
  );
};

export default NewHeroCarousel;
